<template>
	<div class="card summary-item">
		<a v-bind:href="item.Url" class="card-content-wrapper card-link-wrapper">
			<div class="card-body">
				<div class="card-body-content-wrapper">
					<div class="card-type" v-if="item.Type.DisplayName">{{ item.Type.DisplayName }}</div>
					<h2 class="card-title">{{ item.Title }}</h2>
					<div v-html="item.Summary"></div>
				</div>
				<div class="card-cta">
					<div class="link m-0" v-bind:class="item.Type.CodeName.toLowerCase()">{{ item.Cta.Text }}</div>
				</div>
			</div>
		</a>
	</div>
</template>

<script>
	export default {
		props: ['item'],
		components: {

		},
		mounted: function () {

		},
		methods: {
        },
    }
</script>